<script setup="">
import { computed, inject } from "vue";

const props = defineProps({
  classes: {
    type: String,
    required: false
  },
  defaultClass: {
    type: String,
    required: false,
    default: "mt-1.5 text-xs text-400"
  }
});

const twMerge = inject("twMerge");
const computedClass = computed(() => twMerge(props.defaultClass, props.classes));
</script>

<template>
  <p :class="computedClass">
    <slot />
  </p>
</template>
